import React from "react";
import { AdminOperationLogTableHead } from "./AdminOperationLogTableHead";
import { AdminOperationLogTableBody } from "./AdminOperationLogTableBody";

export const AdminOperationLogTable = React.memo(function AdminOperationLogTable() {
    return (
        <table>
            <AdminOperationLogTableHead />
            <AdminOperationLogTableBody />
        </table>
    );
});
